import React, { Component, ErrorInfo, ReactNode } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { isDatadogEnabled } from "~/helpers/datadogRum";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

const CHUNK_LOAD_ERROR_PATTERN =
  /importing a module script failed|failed to fetch dynamically imported module|error loading dynamically imported module/i;
const CHUNK_RELOAD_KEY = "chunk-load-error-reload";

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (isDatadogEnabled()) {
      datadogRum.addError(error, {
        source: "react-error-boundary",
        url: typeof window !== "undefined" ? window.location.href : undefined,
        componentStack: errorInfo.componentStack,
      });
    }

    // Stale chunk hash after a new deploy: reload once to fetch the current build.
    if (
      CHUNK_LOAD_ERROR_PATTERN.test(error.message) &&
      !sessionStorage.getItem(CHUNK_RELOAD_KEY)
    ) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong</div>;
    }

    return this.props.children;
  }
}
